export const civilLawConst = {
  path: "/single-programs/civil-law",
  title: "ФАКУЛЬТЕТ ПРАВА — ГРАЖДАНСКОЕ ПРАВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Гражданское право — фундамент правовой системы</h2>
      <p>
        Гражданское право охватывает широкий спектр вопросов: от личных прав до имущественных споров, от контрактов до наследства. Это
        направление подходит тем, кто стремится защищать интересы граждан, компаний и организаций в правовом поле.
      </p>
      <p>
        Программа направлена на глубокое изучение норм частного права, правоприменительной практики и законодательных систем ЕС. Студенты
        изучают как национальные правовые нормы, так и европейское частное право.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общая теория гражданского права</li>
        <li>Договорное право и обязательства</li>
        <li>Наследственное и семейное право</li>
        <li>Имущественные и жилищные споры</li>
        <li>Защита прав потребителей</li>
        <li>Судебная практика и процессуальное право</li>
        <li>Нотариат и регистрационные процедуры</li>
        <li>Правовое сопровождение бизнеса</li>
      </ul>
      <p>
        Курсы ориентированы на практику: вы разберете реальные кейсы, научитесь составлять договоры и участвовать в юридических процедурах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Юрист по гражданским делам</li>
        <li>Юрисконсульт в частной компании</li>
        <li>Нотариус (после дополнительной квалификации)</li>
        <li>Специалист по правовому сопровождению сделок</li>
        <li>Эксперт по жилищным, семейным или наследственным вопросам</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€50,000 до €95,000 в год,</strong> в зависимости от специализации и страны.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, соответствующий стандартам ЕС</li>
        <li>Программа доступна на русском и английском языках</li>
        <li>Обучение онлайн или очно — по вашему выбору</li>
        <li>Практические навыки и подготовка к юридической карьере</li>
        <li>Поддержка в стажировках и выходе на рынок труда в ЕС</li>
        <li>Индивидуальное сопровождение студентов</li>
      </ul>
      <p>Гражданское право — это профессия, где каждый кейс важен, а знание закона — инструмент справедливости.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на каждом этапе: от выбора программы до оформления документов.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Гражданское право — фундамент правовой системы
    Гражданское право охватывает широкий спектр вопросов: от личных прав до имущественных споров, от контрактов до наследства. Это направление подходит тем, кто стремится защищать интересы граждан, компаний и организаций в правовом поле.
    Программа направлена на глубокое изучение норм частного права, правоприменительной практики и законодательных систем ЕС. Студенты изучают как национальные правовые нормы, так и европейское частное право.
    Что вы будете изучать?
    • Общая теория гражданского права
    • Договорное право и обязательства
    • Наследственное и семейное право
    • Имущественные и жилищные споры
    • Защита прав потребителей
    • Судебная практика и процессуальное право
    • Нотариат и регистрационные процедуры
    • Правовое сопровождение бизнеса
    Курсы ориентированы на практику: вы разберете реальные кейсы, научитесь составлять договоры и участвовать в юридических процедурах.
    Кем можно работать после окончания?
    • Юрист по гражданским делам
    • Юрисконсульт в частной компании
    • Нотариус (после дополнительной квалификации)
    • Специалист по правовому сопровождению сделок
    • Эксперт по жилищным, семейным или наследственным вопросам
    Зарплата в Европе: от €50,000 до €95,000 в год, в зависимости от специализации и страны.
    Почему выбирают нас?
    • Европейский диплом, соответствующий стандартам ЕС
    • Программа доступна на русском и английском языках
    • Обучение онлайн или очно — по вашему выбору
    • Практические навыки и подготовка к юридической карьере
    • Поддержка в стажировках и выходе на рынок труда в ЕС
    • Индивидуальное сопровождение студентов
    Гражданское право — это профессия, где каждый кейс важен, а знание закона — инструмент справедливости.
    Как поступить? 
    Приёмная комиссия сопровождает вас на каждом этапе: от выбора программы до оформления документов.
  `,
};
